<template>
  <div id="modal_popup_campaign" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_campaign', false)" class="close-button">
        <img src="@/assets/images/cms-mkt/close-button.svg" />
      </a>
      <div class="offer-details-wrapper">
        <div class="addRewardLayout border-box flex-wrap flex-xl-nowrap justify-content-center">
          <div class="container-fluid d-flex flex-column align-items-center">
            <div class="d-flex flex-row align-items-center">
              <div class="row d-flex flex-column align-items-baseline w-80">
                <strong class="text-break">{{ $t("categoryField") }}</strong>
                <!-- <input type="text" v-model="newCampaign.category" class="formedituser w-100" /> -->
                <div class="radioButtonCustom">
                  <label v-for="(category, index) in categories" :key="index">
                    <input name="categoryType" type="radio" :value="category"
                      @change="selectCategory($event.target, category)"
                      :checked="category === newCampaign.category"
                      :v-model="newCampaign.category">
                    {{ $t('campaignCategory' + category) }}</label>
                </div>
                <!-- <multiselect v-model="newCampaign.category" :options="categoriesSelect" class="margin-top-1rem" -->
                <!-- :placeholder="$t('cmsLang.selectLabel')" select-label="" selected-label="" deselect-label="" /> -->
              </div>
              <div class="row d-flex flex-column align-items-baseline w-80">
                <strong class="text-break">{{ $t("widgetField") }}</strong>
                <!-- <input type="text" v-model="newCampaign.category" class="formedituser w-100" /> -->
                <div class="radioButtonCustom">
                  <label v-for="(widget, index) in widgets" :key="index">
                    <input name="widgetType" type="radio" :value="widget"
                      @change="selectWidget($event.target, widget)"
                      :checked="widget === newCampaign.widgetType">
                    {{ widget }}</label>
                </div>
                <!-- <multiselect v-model="newCampaign.category" :options="categoriesSelect" class="margin-top-1rem" -->
                <!-- :placeholder="$t('cmsLang.selectLabel')" select-label="" selected-label="" deselect-label="" /> -->
              </div>
            </div>
            <br />
            <!-- <p v-html="$t('cmsLang.imageWarning')" class="orange"></p> -->

            <div class="row d-flex flex-row justify-content-around w-80" v-if="this.newCampaign.i18">
              <div class="border-color-11 w-45"  v-for="(texts, index) in this.newCampaign.i18" :key="index">
                <h5 >{{ $t('language_' + texts.language) }}</h5>
              <strong >{{ $t("titleField") }}</strong>
                <div class=" d-flex flex-column align-items-baseline ">
                  <input type="text" required v-model="texts.title" class="formedituser w-100" />
                </div>
              <strong >{{ $t("summaryField") }}</strong>
              <div class=" d-flex flex-column align-items-baseline">
                <textarea required v-model="texts.summary" class="formedituser w-100" maxlength="500" />
              </div>   
                            <strong >{{ $t("urlField") }}</strong>
                <div class=" d-flex flex-column align-items-baseline ">
                  <input type="text" required v-model="texts.url_link" class="formedituser w-100" />
                </div>           
              <br />
              <div class="uploadImageDiv w-100">
                <div @click="uploadImageClicked('fileInput' + texts.language)" :id="'fileContainer' + texts.language">
                  <div :key="texts.previewImage" >
                    <div v-if="texts.previewImage" class="offer-preview-image"
                    :style="{ 'background-image': `url(${texts.previewImage})` }">
                    </div>

                    <div v-else-if="texts.url_image" class="offer-preview-image  w-100"
                    :style="{ 'background-image': `url(${texts.url_image})` }">
                    </div>
                    <div v-else class="offer-preview-image  w-100"
                    :style="{ 'background-image': `url(${require('@/assets/images/cms-mkt/offer_0.svg')})` }">
                    </div>
                  </div>
                  <br />
                  <!-- <p v-html="$t('cmsLang.imageInfoLabel')"  >                 </p> -->
                  <div :key="texts.imageError" v-if="texts.imageError && texts.imageError.length > 0">
                    "Eroare"
                    <p v-for="(entry, index) in texts.imageError" :key="index" class="red">{{ entry.description ?
                      entry.error_code + " : " +
                      entry.description : $t('cmsLang.errorMessage_' + entry) }}</p>
                  </div>
                  <!-- <p v-html="$t('cmsLang.imageError')" class="red" v-if="this.imageError"></p> -->
                  <p v-else></p>
                  <div class="row d-flex flex-column align-items-baseline w-80">
                    <strong class="text-break">{{ $t("cmsLang.imageLabel") }}</strong>
                    </div>
                    <!-- <a @click="$refs.fileInput1.click()" class="uploadFile">
                    {{ $t("cmsLang.uploadImageLabel") }}</a> -->
                  <input type="file" @change="uploadFile('fileInput' + texts.language, texts)" :ref="'fileInput' + texts.language" style="display: none"
                  accept=".png, .jpg, .jpeg, .mp4" />
                </div>

                <div class="w-100 text-left">
                  <a @click="resetImage('fileInput' + texts.language, texts)" class="status-background background-will-expire color-darkgrey">Reset</a>
                </div>
              </div>
              </div>
            </div>
            <br/>
            <div class=" d-flex flex-row justify-content-between w-80">
            <div class="row d-flex flex-column align-items-baseline w-80">
              <strong class="text-break">{{ $t("priorityField") }}</strong>
              <input type="number" v-model="newCampaign.priority" class="formedituser w-80" onwheel="return false;"/>
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <strong class="text-break">{{ $t("clientField") }}</strong>
              <input type="number" v-model="newCampaign.filters.fiscal" class="formedituser w-80" onwheel="return false;"/>
            </div>
            </div>
            <div class=" d-flex flex-row justify-content-between w-80">
                <div class="row d-flex flex-column align-items-baseline w-80">
                <strong class="text-break">{{ $t("startDateLabel") }}</strong>
                <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                  :time="newCampaign.startDate" @close="startDateSelected" :openDirection="true"/>
                </div>
                <div class="row d-flex flex-column align-items-baseline w-80">
                <strong class="text-break">{{ $t("endDateLabel") }}</strong>
                <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                  :time="newCampaign.endDate" @close="endDateSelected" />
              </div>
              <p v-html="$t('cmsLang.gameDateError')" class="red" v-if="this.dateError"></p>
              <p v-else></p>
            </div>

            <div class="row d-flex flex-column align-items-baseline w-80 border-round-white">

              <strong class="text-break">{{ $t("locationsField") }}</strong>
              <multiselect v-if="this.locations" v-model="newCampaign.location" :options="this.locations" :placeholder="$t('cmsLang.selectLabel')"
              select-label="" selected-label="" deselect-label="" :multiple="true" openDirection="bottom" 
              track-by="id" label="name" id="locationsMultiselect"></multiselect>
              
              <strong class="text-break">{{ $t("cmsLang.partnerTargetLabel") }}</strong>
              <multiselect v-if="this.partners" v-model="newCampaign.partner" :options="this.partners" :placeholder="$t('cmsLang.selectLabel')"
              select-label="" selected-label="" deselect-label=""  @select="selectNewCampaignPartner($event)" :multiple=false openDirection="bottom" :limit="1"
              track-by="id" label="name" ></multiselect>
              
              <strong class="text-break">{{ $t("cmsLang.productLabel") }}</strong>
              <!-- <input type="text" v-model="newGame.category" class="formedituser w-100" /> -->
              <multiselect v-model="newCampaign.filters.product" :options="this.products" :placeholder="$t('cmsLang.selectLabel')"
              select-label="" selected-label="" deselect-label="" :multiple="true" openDirection="bottom" 
              :custom-label="customLabelProduct" ></multiselect>
            </div>
            <div v-if="this.isCampaignVoucher" class="row d-flex flex-column align-items-baseline w-80 border-round-white">
              
              <p v-html="$t('searchPartnerWarning')" class="orange"></p>
              <span>
                <a class="button-all button-orange" @click="getAffiliates()"> {{ $t('searchWorkspaceLabel') }}</a>
                &nbsp;
                <input type="checkbox" @change="selectAllAffiliates" />
                {{ $t("selectAllWorkspace") }}
              </span>
              <br />
              <multiselect v-model="newCampaign.affiliates" :options="affiliates" :placeholder="$t('cmsLang.selectLabel')"
                select-label="" selected-label="" deselect-label="" :multiple=true openDirection="bottom"
                track-by="codfou" :custom-label="customLabelAffiliate" :loading="isLoading" :limit=1></multiselect>
              <br />

              <div class="row d-flex flex-column align-items-baseline border-round-white" >
              <strong class="text-break">{{ $t("voucherTitle") }}</strong>
                 <table
                    cellpadding="10"
                    cellspacing="0"
                    width="100%"
                    class="hover-table invoices-table"
                    align="center"
                  >
                    <thead>
                      <tr>
                        <td valign="middle">
                          <small>{{ $t("titleLabel") }}</small>
                        </td>
                        <td valign="middle">
                          <small>{{ $t("invoiceAmountHeader") }}</small>
                        </td>
                        <td valign="middle">
                          <small>{{ $t("availabilityHeader") }}</small>
                        </td>
                        <td valign="middle">
                          <small>{{ $t("minVoucherValueHeader") }}</small>
                        </td>                      
                        <td valign="middle">
                          <small>{{ $t("maxVoucherValueHeader") }}</small>
                        </td>
                      </tr>
                    </thead>
                    
                    <tbody>
                      <template v-for="(voucher, index) in offerVouchers">
                        <tr
                          :key="index"
                          class="trhover parent"
                          :class="index % 2 === 0 && 'gri-cell'"
                        >
                          <td valign="middle">
                            {{ voucher.title }}
                          </td>
                          <td valign="middle">
                            {{ voucher.value }}
                          </td>
                            <td valign="middle">
                            {{ voucher.stock.total_available + "/" + voucher.stock.total_assigned + "(" + voucher.stock.stock_level + ")" }}
                          </td>
                          <td valign="middle">
                            <input type="number" v-model="voucher.min_value" class="formedituser w-100" onwheel="return false;"/>
                          </td>
                          <td valign="middle">
                            <input type="number" v-model="voucher.max_value" class="formedituser w-100" onwheel="return false;"/>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
              </div>
            </div>

            <div v-if="this.error" class="row d-flex flex-column align-items-baseline w-80">
            <br />
            <p  v-if="this.error.error_code">
              {{ this.error.description ? this.error.description : $t('commercialError_' + this.error.error_code) }}
            </p>
            <p v-else class="error" v-for="(error, index) in this.error" :key="index">
            {{ error.description ? error.description : $t('commercialError_' + error.error_code) }}
            </p>            
          </div>
            <br />
            <div class="row d-flex flex-column align-items-baseline w-80">
              <div class="row d-flex flex-row align-items-baseline justify-content-between w-80">
                <a @click="submitCampaign(false)" class="button-all button-orange">
                  {{ $t('saveLabel') }}
                </a>
                 <!-- v-if="newCampaign.id > 0 && newCampaign.status !== 'A'" -->
                <a @click="showModalPopup('modal_popup_confirm_approve', true)" class="button-all button-orange" >
                  {{ $t('publishLabel') }}

                </a>
                <a @click="showModalPopup('modal_popup_confirm', true)" class="button-all button-red"  v-if="newCampaign.id > 0">
                  {{ $t('deleteLabel') }}

                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import moment from "moment";
  // import validator from "@/plugins/fieldValidation";
  import DateRange from "@/components/DateRange.vue";
  // import { VueEditor } from "vue2-editor";
  import httpServiceCustomer from "@/http/http-commercial.js";
  import Cookies from "js-cookie";

  export default {
    name: "NewCommercialCampaignPopup",

    props: {
      user: Object,
      campaign: Object,
      image: String,
      categories: Array,
      locations: Array,
      partners: Array,
      widgets: Array
    },
    components: {
      DateRange,
      // VueEditor
    },
    data() {
      return {
        selectedCategory: false,
        newCampaign: {
          i18: [
            {
              language: "ro",
              title: "",
              summary: "",
              previewImage: null,
              imageError: []
            },
            {
              language: "en",
              title: "",
              summary: "",
              previewImage: null,
              imageError: []
            }
          ],
          priority: 0,
          category: "",
          widgetType: "",
          startDate: [],
          endDate: [],
          partnerId: 0,
          filters: {
            product: [],
            fiscal: "",
            location: []
          },
          location: [],
          image: null,
        },
        offerVouchers: [],
        affiliates: [],
        isAmount: false,
        minDate: moment().toDate(),
        products: [11, 12, 13, 14, 15],
        // products: [11],
        dateError: false,
        error: null,
        affiliatesFilter: {
          code: "",
          fiscalCode: "",
        },
        isLoading: false,
        isSelectedAllAffiliates: false
      };
    },
    methods: {
      selectCategory(element, entry) {
        this.newCampaign.category = entry;
      },
      selectWidget(element, widgetType) {
        this.newCampaign.widgetType = widgetType;
      },
      selectAllAffiliates() {
        this.isSelectedAllAffiliates = !this.isSelectedAllAffiliates;
        if (this.isSelectedAllAffiliates) {
          this.newCampaign.affiliates = this.affiliates;
        } else {
          this.newCampaign.affiliates = [];
        }
      },

      submitCampaign(approve) {
        this.error = null;

        this.showModalPopup("modal_popup_loading", true);

        let submitCampaign = {
          widget_type: this.newCampaign.widgetType,
          category: this.newCampaign.category,
          priority: this.newCampaign.priority,
          i18: this.newCampaign.i18
        }
        if (this.newCampaign.id > 0) {
          submitCampaign.id = this.newCampaign.id;
        }

        if (this.newCampaign.endDate.length > 0) {
          submitCampaign.end_date = moment(this.newCampaign.endDate[0]).format('DD-MM-YYYY');
        }
        if (this.newCampaign.startDate.length > 0) {
          submitCampaign.start_date = moment(this.newCampaign.startDate[0]).format('DD-MM-YYYY');
        }
        if (this.newCampaign.partner) {
          submitCampaign.partner_id = this.newCampaign.partner.id;
        }

        submitCampaign.location = this.newCampaign.location,
          submitCampaign.filters = []
        if (this.newCampaign.filters.product.length > 0) {
          submitCampaign.filters.push(
            {
              type: "product",
              values: {
                id: this.newCampaign.filters.product
              }

            },)
        }
        if (this.newCampaign.filters.fiscal.length > 0) {
          submitCampaign.filters.push(
            {
              type: "fiscal",
              values: {
                id: [this.newCampaign.filters.fiscal]
              }
            })
        }
        if (this.newCampaign.location.length > 0) {
          submitCampaign.filters.push(
            {
              type: "location",
              values: {
                id: [this.newCampaign.location]
              }
            })
        }
        if (this.isCampaignVoucher) {
          submitCampaign.offer_vouchers = this.offerVouchers.filter(x => x.max_value > 0 && x.min_value > 0);

        }

        if (approve) {
          this.approveCampaign(submitCampaign);
        } else if (this.newCampaign.id > 0) {
          this.updateCampaign(submitCampaign);
        } else {
          this.addNewCampaign(submitCampaign);
        }
      },
      approveCampaign(campaign) {
        this.$emit("approve", campaign);
      },
      updateCampaign(campaign) {
        httpServiceCustomer.customerService
          .updateCampaign(
            campaign,
            Cookies.get("token")
          ).catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.$emit("showinfo", "campaignUpdateSuccess", null);
              this.$emit("updatelist");
            } else if (response.status == 400) {
              this.error = response.data;
              // this.$emit("showinfo", "", this.error);
            } else {
              this.error = [{ code: "500" }]
            }
            this.showModalPopup("modal_popup_loading", false);
            // this.showModalPopup("modal_popup_info", true);
          })
        // .catch((error) => {
        //   if (error.response) {
        //     this.error = error.response.data;
        //   } else {
        //     this.error = ["undefined"];
        //   }
        //   // this.showModalPopup("modal_popup_loading", false);
        //   this.showModalPopup("modal_popup_info", true);
        //   this.$emit("showinfo", "", this.error);
        // });
      },
      addNewCampaign(campaign) {
        httpServiceCustomer.customerService
          .addCampaign(
            campaign,
            Cookies.get("token")
          ).catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.$emit("showinfo", "campaignAddSuccess", null);
              this.$emit("updatelist");
            } else if (response.status == 400) {
              this.error = response.data;
              this.$emit("showinfo", "", this.error);
            } else {
              this.error = [{ code: "500" }]
            }
            this.showModalPopup("modal_popup_loading", false);
            // this.showModalPopup("modal_popup_info", true);
          });
      },
      uploadImageClicked(referenceId) {
        // let inputId = 'fileinput' + language
        this.$refs[referenceId][0].click();
      },
      uploadFile(referenceId, text) {
        text.imageError = null;
        this.newCampaign.image = null;
        text.previewImage = null;
        let input = this.$refs[referenceId][0];

        let file = input.files;
        if (file && file[0]) {
          let reader = new FileReader();
          reader.onload = (e) => {
            text.previewImage = e.target.result;
          };

          reader.readAsDataURL(file[0]);
          if (reader.readAsBinaryString) {
            console.log("read as binary string");
          } else {
            alert("This browser does not support HTML5.");
          }

          let readerReward = new FileReader();
          readerReward.onload = (e) => {
            if (!e) {
              this.newCampaign.image = btoa(readerReward.content);
            } else {
              this.newCampaign.image = btoa(e.target.result);
            }
            this.validateFile(file[0].name, text);
          };
          // reader.readAsDataURL(file[0]);
          if (readerReward.readAsBinaryString) {
            readerReward.readAsBinaryString(file[0]);
          } else {
            alert("This browser does not support HTML5.");
          }


        }
      },
      validateFile(name, text) {
        if (this.newCampaign.image) {
          text.isLoading = true;
          httpServiceCustomer.customerService
            .validateImage({
              type: this.newCampaign.widgetType,
              language: text.language,
              name: name,
              content: this.newCampaign.image
            }, Cookies.get("token"))
            .then(function (response) {
              return response;
            })
            .catch((error) => {
              return error.response;
            })
            .then((response) => {
              if (response.status == 200) {
                this.newCampaign.i18.forEach((x) => {
                  if (x.language === text.language) {
                    x.url_image = response.data.url_image;
                    x.url_video = response.data.url_video;
                  }
                  $('fileContainer' + texts.language).forceUpdate();
                });
              } else {
                text.imageError = [response.data];
              }
              text.isLoading = false;
              this.$forceUpdate();
            });
        }
      },
      resetImage(referenceId, text) {
        this.$refs[referenceId][0].value = null;
        text.previewImage = null;
        text.imageError = null;
      },
      customLabelProduct(param) {
        return this.$t('cmsLang.product_' + param);
      },
      customLabelAffiliate({ codfou, address, county }) {
        return `${codfou} – ${county}, ${address} `;
      },
      getAffiliates() {
        this.affiliates = [];
        this.isSelectedAllAffiliates = false;
        // @queryParam name = search by name
        if (!this.newCampaign.product) {
          return;
        }

        httpServiceCustomer.customerService
          .getWorkpoints({
            locations: this.newCampaign.location,
            filters: [
              {
                type: "product",
                values: {
                  id: this.newCampaign.filters.product
                }

              },
              {
                type: "fiscal",
                values: {
                  id: [this.newCampaign.partner.fiscal]
                }
              }
            ]
          }, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            // this.error = {
            //   code: error.response.data,
            //   description: error.response.data,
            // };
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.affiliates = response.data;
              this.isLoading = false;

              // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
            } else if (response.status == 400 || response.status == 403) {
              this.isLoading = false;
            } else {
              this.isLoading = false;
            }

          });
      },
      getVouchersForPartner() {
        this.offerVouchers = [];
        // @queryParam name = search by name
        if (!this.newCampaign.partner) {
          return;
        }

        httpServiceCustomer.customerService
          .getVouchersForPartner(
            this.newCampaign.partner.id
            , Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            // this.error = {
            //   code: error.response.data,
            //   description: error.response.data,
            // };
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.offerVouchers = response.data;
              if (this.newCampaign.offer_vouchers) {
                this.offerVouchers.forEach((voucher) => {
                  voucherExist = this.offerVouchers.find(({ id }) => id === voucher.id
                  )
                })
              }
            } else if (response.status == 400 || response.status == 403) {
            }

          });
      },
      selectNewCampaignPartner(element) {
        this.newCampaign.partner = element;
        if (element.id === this.campaign.partner.id) {
          this.offerVouchers = this.campaign.offer_vouchers
        } else {
          this.offerVouchers = [];
          this.getVouchersForPartner();
        }
      },
      startDateSelected(value) {
        if (this.newCampaign.endDate[0] < value[0]) {
          this.dateError = true;
          this.newCampaign.startDate = value;
        } else {
          this.dateError = false;
          this.newCampaign.startDate = value;
        }
      },
      endDateSelected(value) {
        if (this.newCampaign.startDate[0] > value[0]) {
          this.dateError = true;
          this.newCampaign.endDate = value;
        } else {
          this.dateError = false;
          this.newCampaign.endDate = value;
        }
      },
      customLabelSubCategory({ subcategory_name }) {
        return `${subcategory_name}`;
      },
      getCategoryById(subcategory_id) {
        return this.subCategoriesSelect.filter(
          x => x.category_id === subcategory_id
        )[0];
      },
      findCategoryByName(category_name) {
        return this.categories.filter(
          x => x.category_name === category_name
        )[0];
      },
      gameImage() {
        if (this.newCampaign.image) {
          return "data:image/png;base64," + this.newCampaign.image
        } else {
        }
      },
      imageUrl(text) {
        if (text.url_image) {
          return text.url_image;
        } else {
          return require('@/assets/images/cms-mkt/offer_0.svg');
        }
        return null;
      },
    },
    computed: {
      isCampaignVoucher() {
        if (this.newCampaign && this.newCampaign.category) {
          switch (this.newCampaign.category) {
            case "vouchers":
              return true;
            default: return false;
          }
        }
        return false;
      },
    },
    watch: {
      campaign: function () {
        //  this.$refs['fileinput' + language].value = null;
        this.error = null;
        if (this.campaign.id > 0) {
          this.newCampaign.id = this.campaign.id;
          this.newCampaign.category = this.campaign.category;
          this.newCampaign.widgetType = this.campaign.widget_type;
          this.newCampaign.priority = this.campaign.priority;
          this.partners.forEach((partner) => {
            if (partner.id === this.campaign.partner.id) {
              this.newCampaign.partner = partner;
              // if (this.newCampaign.category === "vouchers") {
              //   this.getVouchersForPartner();
              //   this.new
              // }
            }
          });
          this.offerVouchers = this.campaign.offer_vouchers;
          this.newCampaign.endDate = this.campaign.end_date ? [moment(this.campaign.end_date, 'DD-MM-YYYY')] : [moment()];
          this.newCampaign.startDate = this.campaign.start_date ? [moment(this.campaign.start_date, 'DD-MM-YYYY')] : [moment()];
          this.newCampaign.status = this.campaign.status;
          // this.newCampaign.filters = this.campaign.filters;
          this.campaign.filters.forEach((filter) => {
            if (filter.values && filter.values.id) {
              if (filter.type === "fiscal") {
                this.newCampaign.filters[filter.type] = filter.values.id[0];
              } else if (filter.type === "product") {
                this.newCampaign.filters[filter.type] = filter.values.id;
              }
            }
          });

          this.newCampaign.location = this.campaign.location;
          this.newCampaign.i18 = this.campaign.i18;
        } else {
          this.newCampaign = {
            id: 0,
            category: "",
            startDate: [moment()],
            endDate: [moment()],
            affiliates: [],
            location: [],
            filters: {
              product: [],
              fiscal: ""
            }
            // checkpoints: []
          };
          this.newCampaign.i18 = [
            {
              language: "ro",
              title: "Romanian Campaign",
              summary: "Campaign description",
              // url_image: "https://cdn.example.com/banner_en.png",
              // url_video: "",
              url_link: "",
              previewImage: null,
              imageError: []
            },
            {
              language: "en",
              title: "Romanian Campaign",
              summary: "Campaign description",
              // url_image: "https://cdn.example.com/banner_en.png",
              // url_video: "",
              url_link: "",
              previewImage: null,
              imageError: []
            }
          ]
        }
        // if (this.campaign.type === 'comercial') {
        //   this.newCampaign.type = 'amount';
        //   this.isAmount = true;
        // }
      },

      isAmount: function (val) {
        if (val) {
          this.newCampaign.type = 'amount';
        } else {
          this.newCampaign.type = 'counter';
        }
      },
    },
    created() {
      this.newCampaign.i18 = [
        {
          language: "ro",
          title: "Romanian Campaign",
          summary: "Campaign description",
        },
        {
          language: "en",
          title: "Romanian Campaign",
          summary: "Campaign description",
        }
      ]
    },
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped src="@/assets/styles/cms-commercial.css"></style>

<style scoped>

  .position {
    position: relative;
    left: 227px;
  }

  .red {
    color: red;
    text-decoration: none;
  }

  .contact-details-wrapper {
    justify-content: space-evenly;
    color: #2D3736;
  }

  .offer-details-wrapper {
    border-radius: 48px;
    overflow-y: auto;
    height: calc(100vh - 170px) !important;
  }

  strong {
    font-size: 18px;
    margin-top: 5px;
  }

  small {
    font-size: 14px;
    font-weight: bold;
  }

  .w-80 {
    width: 90% !important;
  }

  .ql-toolbar.ql-snow {
    border: 2px solid #fff !important;
    border-radius: 48px !important;
  }

  .multiselect {
    border: 1px solid #d8d8d8;
    background: #f1f1f1 !important;
    height: 40px !important;
    /* border-radius: 20px; */

  }

  .multiselect__input {
    font-size: 15px !important;
    /* border-radius: 20px !important; */
  }

  .multiselect__tags {
    border-radius: 40px !important;
    padding: 8px -30px 0 8px !important;
  }

  .modal-popup-content {
    min-width: 800px !important;
  }

  .offer-details-wrapper {
    width: 100%;
  }

  .w-45 {
    width: 45%;
  }

</style>
